<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p>Thank you to everyone at Austin Macauley Publishers for truly believing in this book and in me. Your belief in me has genuinely been a healing experience. Thank you to Sabah Khodir for being the mentor I always needed. You believed in me, encouraged me to keep writing and publish my poetry at a time when I didn’t think it could happen and helped me transform my writing into what it was always meant to become. Thank you to every writer who gave their grief space in their writing, it has shown me the way. Thank you to my favourite artist in music, Taylor Swift, for putting out <em>Folklore</em>, <em>Evermore</em> and <em>Red</em> (Taylor’s version) at the same time I was writing this book. They helped me process my grief and inspired me to express it. Ibram Fawzy, for guiding me on the healing journey that allowed me to write this book. Mom, for proving to me that unconditional love is real. Dad, for giving me everything. God, for making every single part of this beautiful equation even possible. I am forever grateful to all of you.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?577628a8